import React from 'react';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const showErrorMessage = () => {
    toast.error('Something Went Wrong! Please try again', {
        position: toast.POSITION.TOP_CENTER,
        className: 'toast-message'
    });
};